module.exports = __webpack_public_path__ + "img/phone1.7cd69149.png";